

























import { Component, Prop } from 'vue-property-decorator';
import { Route } from 'vue-router';
import EditResourceItem from '@/components/resources/EditResourceItem';
import VerticalForm from '@/components/forms/VerticalForm.vue';
import ProductVariantResourceProxy from '@/resources/products/variants/ProductVariantResourceProxy';

@Component({
  components: {
    VerticalForm,
  },
})
export default class EditVariantPage extends EditResourceItem {
  @Prop({ type: String, required: true }) readonly productId!: string;
  created() {
    this.bootstrapComponent();
  }

  mounted() {
    this.initializeItem();
  }

  beforeRouteEnter(to: Route, from: Route, next: Function) {
    next((vm: EditVariantPage) => vm.initializeItem(to.params.variantId));
  }

  beforeRouteUpdate(to: Route, from: Route, next: Function) {
    this.initializeItem(to.params.variantId);
    next();
  }

  protected createResourceProxy() {
    this.resourceProxy = new ProductVariantResourceProxy(() => this.productId);
  }

  // Handle "item updated" event.
  protected itemHasBeenUpdated() {
    if (this.item) {
      this.$vs.notify(this.resourceProxy.getUpdatedNotification(this.item));
    }
  }

  // Handle "item update failed" event.
  protected itemUpdateFailed(err: any) {
    if (this.item) {
      this.$vs.notify(this.resourceProxy.getUpdateFailedNotification(this.item, err));
    }
  }
}
